import { render, staticRenderFns } from "./r-card-cluster-dropdown.vue?vue&type=template&id=56fb66cf"
import script from "./r-card-cluster-dropdown.vue?vue&type=script&lang=js"
export * from "./r-card-cluster-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fb66cf')) {
      api.createRecord('56fb66cf', component.options)
    } else {
      api.reload('56fb66cf', component.options)
    }
    module.hot.accept("./r-card-cluster-dropdown.vue?vue&type=template&id=56fb66cf", function () {
      api.rerender('56fb66cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card-cluster/r-card-cluster-dropdown.vue"
export default component.exports